module.exports = __webpack_public_path__ + "static/media/InactiveNextButton.50e19f71.svg";